import { css } from '@emotion/react';
import { Trans } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens, Link, Dropdown, Icon } from '@hotjar/hotsauce';
import { useCurrentSite } from '@hotjar/site';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { WidgetContainer } from './Widget';

interface SessionCaptureDisabledProps {
  trackIndicatorClick: (elementName: string) => void;
  trackClick: (elementName: string, shownTrafficCoverage?: number | null) => void;
  trackView: (elementName: string, shownTrafficCoverage?: number | null) => void;
}

const S = {
  Container: styled.div`
    ${tokens.flexContainer('default', { gap: tokens.spacer.x1 })};
    padding: ${tokens.spacer.x2};
  `,
};

export const SessionCaptureDisabled = ({
  trackIndicatorClick,
  trackClick,
  trackView,
}: SessionCaptureDisabledProps): JSX.Element => {
  const { t } = useTranslationWithPrefix('common:sampling-widget');
  const currentSite = useCurrentSite().data;

  return (
    <Dropdown
      css={css`
        background-color: ${tokens.color.bg_warning};
        color: ${tokens.color.text_default};
      `}
      onShow={() => trackView('session_capture_disabled_warning')}
      trigger={
        <WidgetContainer
          iconComponent={<Icon color="text_warning" icon="warning_alt" size="m" />}
          text={t('session-capture-disabled')}
          onClick={() => trackIndicatorClick('session_capture_disabled_traffic_coverage_indicator')}
        />
      }
    >
      <S.Container>
        <div>
          <Icon color="text_default" icon="info_alt" size="m" />
        </div>
        <div>
          <span
            css={css`
              font-weight: 600;
            `}
          >
            <Trans i18nKey="common:sampling-widget.currently-disabled" />
          </span>{' '}
          <Trans i18nKey="common:sampling-widget.to-record" />{' '}
          <Link
            kind="inline"
            onClick={() => trackClick('session_capture_disabled_warning-link-to-site-settings')}
            href={`/site/${currentSite?.id}/settings`}
            isExternal
          >
            {t('site-settings')}
          </Link>
          .
        </div>
      </S.Container>
    </Dropdown>
  );
};
